// Service de thème PROGÈRE — dark / light / system (préférence partagée).
const KEY = "progere-theme";

export function resolveTheme(pref) {
  if (pref === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return pref === "light" ? "light" : "dark";
}

export function applyProgereTheme(pref) {
  const root = document.documentElement;
  const resolved = resolveTheme(pref);
  root.setAttribute("data-theme", resolved);
  root.setAttribute("data-theme-preference", pref);
  root.classList.toggle("theme-light", resolved === "light");
  try { localStorage.setItem(KEY, pref); } catch (e) {}
}

export function getThemePreference() {
  try { return localStorage.getItem(KEY) || "dark"; } catch (e) { return "dark"; }
}

export function loadProgereTheme() {
  applyProgereTheme(getThemePreference());
}
